import "./bootstrap";
import moment from "moment";
window.moment = moment;

import { createApp } from "vue";
import { createPinia } from "pinia";
import { VueReCaptcha, useReCaptcha } from "vue-recaptcha-v3";
const pinia = createPinia();

import router from "./router";
import App from "./App.vue";

import LitepieDatepicker from "litepie-datepicker-tw3";

import "../css/app.css";

import axios from "axios";
import { Model } from "vue-api-query";

// inject global axios instance as http client to Model
Model.$http = axios;
import Notifications from "notiwind";
import VueClipboard from "vue3-clipboard";
import Toast from "vue-toastification";
import FloatingVue from "floating-vue";
import "vue-toastification/dist/index.css";
import "floating-vue/dist/style.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faSort,
    faSortDown,
    faHistory,
    faDownload,
    faExclamationTriangle,
    faRss,
    faEnvelopeOpen,
    faBell,
    faUserTie,
    faGlobe,
    faStar,
    faDollarSign,
    faCoins,
    faWallet,
    faMoneyBillTransfer,
    faSignIn,
    faBook,
    faBox,
    faPersonChalkboard,
    faCode,
    faSackDollar,
    faCartShopping,
    faVideo,
    faCreditCard,
    faMoneyBillAlt,
    faBarcode,
    faCirclePlus,
    faChevronDown,
    faTrash,
    faBan,
    faCheck,
    faMoneyCheckDollar,
    faGear,
    faFileExcel,
    faCircleInfo,
    faCircleQuestion,
    faTimes,
    faEnvelope,
    faMoneyBills,
    faPencilAlt,
    faPencil,
    faCreditCardAlt,
    faEye,
    faEyeSlash,
    faBolt,
    faFlask,
    faChartBar,
    faCheckCircle,
    faSlidersH,
    faChartLine,
    faBalanceScale,
    faPlayCircle,
    faSync,
    faSpinner,
    faPlay,
    faSearch,
    faCog,
    faInfoCircle,
    faRocket,
    faLaptop,
    faClock,
    faArrowUp,
    faArrowDown,
    faUsers,
    faArrowLeft,
    faUpload,
} from "@fortawesome/free-solid-svg-icons";
import {
    faPix,
    faChrome,
    faSafari,
    faOpera,
    faFirefox,
    faApple,
    faWindows,
    faAndroid,
    faEdge,
    faInstagram,
    faCcVisa,
    faCcMastercard,
    faCcAmex,
    faDiscord,
} from "@fortawesome/free-brands-svg-icons";

library.add(
    faSort,
    faSortDown,
    faHistory,
    faDownload,
    faExclamationTriangle,
    faClock,
    faBolt,
    faRss,
    faEnvelopeOpen,
    faBell,
    faUserTie,
    faGlobe,
    faStar,
    faDollarSign,
    faCoins,
    faWallet,
    faMoneyBillTransfer,
    faCreditCardAlt,
    faInstagram,
    faSignIn,
    faBox,
    faPersonChalkboard,
    faBook,
    faCode,
    faSackDollar,
    faCartShopping,
    faVideo,
    faCreditCard,
    faPix,
    faMoneyBillAlt,
    faBarcode,
    faCirclePlus,
    faChevronDown,
    faTrash,
    faBan,
    faCheck,
    faBarcode,
    faMoneyCheckDollar,
    faGear,
    faCircleInfo,
    faCircleQuestion,
    faFileExcel,
    faFlask,
    faChartBar,
    faCheckCircle,
    faSlidersH,
    faChartLine,
    faBalanceScale,
    faPlayCircle,
    faSync,
    faSpinner,
    faPlay,
    faSearch,
    faCog,
    faInfoCircle,
    faRocket,
    faLaptop,
    faClock,
    faTimes,
    faEnvelope,
    faMoneyBills,
    faPencilAlt,
    faPencil,
    faCartShopping,
    faChrome,
    faSafari,
    faOpera,
    faFirefox,
    faApple,
    faWindows,
    faAndroid,
    faEdge,
    faCcVisa,
    faCcMastercard,
    faCcAmex,
    faEye,
    faEyeSlash,
    faDiscord,
    faArrowUp,
    faArrowDown,
    faUsers,
    faArrowLeft,
    faUpload,
);
import Highcharts from 'highcharts';
import VueHighcharts from 'vue-highcharts';

const app = createApp(App)
    .use(VueHighcharts, { Highcharts })
    .use(LitepieDatepicker)

    .use(Notifications)
    .use(pinia)
    .use(Toast, {
        position: 'top-right',
        timeout: 3000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: 'button',
        icon: true,
        rtl: false
    })
    .use(FloatingVue)
    .use(VueClipboard, {
        autoSetContainer: true,
        appendToBody: true,
    })
    .component("font-awesome-icon", FontAwesomeIcon)
    .use(VueReCaptcha, { siteKey: "6LeCmXYlAAAAAPRP_--XeSnXTRlatxnrcYeawIE7" });

app.use(router).mount("#app");
